import parse from 'html-react-parser';
import 'react';
import { jsx, Fragment } from 'react/jsx-runtime';

const Text = ({
  item
}) => {
  return /*#__PURE__*/jsx(Fragment, {
    children: parse(item.htmlContent)
  });
};

export { Text };
//# sourceMappingURL=Text.js.map
